import React, { useState } from "react";
import { getClientSmartContractByShipmentId } from "../../../api/smartContractService";

export default function ClientSmartContractPage() {
    const [shipmentId, setShipmentId] = useState("");
    const [contract, setContract] = useState(null);
    const [error, setError] = useState("");

    const loadContract = async () => {
        try {
            setError("");
            setContract(null);

            if (!shipmentId || Number(shipmentId) <= 0) {
                setError("Shipment ID is required.");
                return;
            }

            const data = await getClientSmartContractByShipmentId(shipmentId);
            setContract(data);
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to load smart contract."
            );
        }
    };

    return (
        <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-bold mb-4">
                My Smart Contract
            </h2>

            {error && <p className="text-red-600 mb-3">{error}</p>}

            <div className="flex gap-3 mb-6">
                <input
                    type="number"
                    value={shipmentId}
                    onChange={(e) => setShipmentId(e.target.value)}
                    placeholder="Shipment ID"
                    className="border p-2 rounded w-48"
                />

                <button
                    onClick={loadContract}
                    className="bg-blue-700 text-white px-4 py-2 rounded"
                >
                    View Contract
                </button>
            </div>

            {contract && (
                <div className="space-y-6">
                    <div className="border rounded p-4 bg-gray-50">
                        <h3 className="text-xl font-bold mb-3">
                            Contract Summary
                        </h3>

                        <p><b>Contract ID:</b> {contract.id}</p>
                        <p><b>Shipment ID:</b> {contract.shipmentId}</p>
                        <p><b>Contract Number:</b> {contract.contractNumber || "�"}</p>
                        <p><b>Status:</b> {contract.status || "�"}</p>
                        <p>
                            <b>Created:</b>{" "}
                            {contract.createdAt
                                ? new Date(contract.createdAt).toLocaleString()
                                : "�"}
                        </p>
                        <p>
                            <b>Approved:</b>{" "}
                            {contract.approvedAt
                                ? new Date(contract.approvedAt).toLocaleString()
                                : "�"}
                        </p>
                    </div>

                    <div className="border rounded p-4">
                        <h3 className="text-lg font-bold mb-3">
                            Contract Clauses
                        </h3>

                        {contract.clauses?.length > 0 ? (
                            <table className="w-full border text-sm">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border p-2">Type</th>
                                        <th className="border p-2">Text</th>
                                        <th className="border p-2">Mandatory</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {contract.clauses.map((clause) => (
                                        <tr key={clause.id}>
                                            <td className="border p-2">
                                                {clause.clauseType || "�"}
                                            </td>
                                            <td className="border p-2">
                                                {clause.text || "�"}
                                            </td>
                                            <td className="border p-2">
                                                {clause.isMandatory ? "Yes" : "No"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p className="text-gray-500">
                                No contract clauses available.
                            </p>
                        )}
                    </div>

                    <div className="border rounded p-4">
                        <h3 className="text-lg font-bold mb-3">
                            Legal Reviews
                        </h3>

                        {contract.legalReviews?.length > 0 ? (
                            <table className="w-full border text-sm">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border p-2">Decision</th>
                                        <th className="border p-2">Comment</th>
                                        <th className="border p-2">Reviewed By</th>
                                        <th className="border p-2">Reviewed At</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {contract.legalReviews.map((review) => (
                                        <tr key={review.id}>
                                            <td className="border p-2">
                                                {review.decision || "�"}
                                            </td>
                                            <td className="border p-2">
                                                {review.comment || "�"}
                                            </td>
                                            <td className="border p-2">
                                                {review.reviewedByUser?.userName ||
                                                    review.reviewedByUser?.email ||
                                                    "�"}
                                            </td>
                                            <td className="border p-2">
                                                {review.reviewedAt
                                                    ? new Date(review.reviewedAt).toLocaleString()
                                                    : "�"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p className="text-gray-500">
                                No legal reviews available.
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}